import TheftRecovery from "./theftRecovery/PluginSetup.js";
import PositionPending from "./positionPending/PluginSetup.js";
export default {
  install: molten => {
    TheftRecovery.install(molten);
    PositionPending.install(molten);
  }
};